import { Env, readFromEnv } from '@cinch-nx/environments'

export const STORYBLOK_BFF_URL = `${readFromEnv(Env.StoryblokBFFComponent)}`
